import MissingPermissionMessage from './MissingPermissionMessage';
import type { MissingPermissionMessageProps } from './types';

export default MissingPermissionMessage;
export type { MissingPermissionMessageProps };
